import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const deleteAgencyPlatform = ({ callback, payload: { id } }) =>
  new Promise((resolve, reject) => {
    const request = apiRequest({ path: `/admin/agency_platforms/${id}`, method: 'DELETE' })
    handleCall(request, resolve, reject, false, {}, callback)
  })
